import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldRadioButton,
  FieldTextInput,
  NamedLink,
  FieldPhoneNumberInput,
  FieldPhoneNumberInputWithDialCode,
  FieldPassword,
  SecondaryButton,
  InlineTextButton,
  Modal,
  FieldNumberInput,
  FieldRadioButtonGroup,
  FieldCustomSelect,
  FieldAddress,
  FieldRecaptcha,
  FieldPerferredLang,
} from '../../components';

import config from '../../config';
import css from './SignupForm.module.css';
import { FormSpy } from 'react-final-form';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { apiBaseUrl } from '../../util/api';
import axios from '../../util/axiosHelper';
import { replaceNumberWithCharacter } from '../../util/richText';
import { listingTypes, sosAdOptions } from '../../marketplace-custom-config';
import { isEmpty } from 'lodash';
import { getDefaultTimeZoneOnBrowser } from '../../util/dates';
import { findOptionsForSelectFilter } from '../../util/search';

const KEY_CODE_ENTER = 13;
const textfield = 'textfield';
const errorTextField = 'errorTextField';
const industryOptions = findOptionsForSelectFilter('industry', config.custom.filters);

export default class ProviderSignup extends Component {
  constructor(props) {
    super(props);
    this.recaptchRef = React.createRef();
    this.state = {
      showOtpModal: false,
      signStep: 0,
      otpValidationInProgress: false,
      isOtpValidated: false,
      wrongOtpError: false,
      otpResend: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isEmailTakenError !== this.props.isEmailTakenError &&
      this.props.isEmailTakenError
    ) {
      const { formApi } = this.props;
      const {
        values: { email },
      } = formApi.getState();
      const entries = [['refEmail', email]];

      this.setState({ signStep: 0 });
      this.formBatchUpdate(entries);
      formApi.focus('email');
      setTimeout(() => formApi.blur('email'), 100);
    }
  }

  handleOnCancelBtnClick = () => {
    const { history } = this.props;
    history.replace(createResourceLocatorString('LandingPage', routeConfiguration()));
  };

  setShowOtpModal = status => {
    this.setState({ showOtpModal: status });
  };

  checkAndHideOtpModal = () => {
    if (this.state.otpValidationInProgress) return;
    this.setShowOtpModal(false);
  };

  requestForOtp = async () => {
    this.setShowOtpModal(true);
    try {
      const { formApi } = this.props;
      const { values } = formApi.getState();
      const {
        phoneNumber: { number, dialCode },
      } = values;
      const mobileNumber = `${dialCode}${number}`;
      const url = `${apiBaseUrl()}/api/user/generate/phoneotp/mobile`;
      await axios.post(url, { mobile: mobileNumber });
    } catch (err) {
      console.error(err);
    }
  };

  formBatchUpdate = (entries = []) => {
    const { formApi } = this.props;
    formApi.batch(() => {
      for (let entry of entries) {
        formApi.change(entry[0], entry[1]);
      }
    });
  };

  // formBatchAndDelayUpdate = (data, hasDelayUpdate = false, delayTimeout = 100) => {
  //   if (typeof data !== 'object' && data.constructor !== Object) return;
  //   const { batchUpdateData = {}, delayUpdateData = {} } = data;
  //   let entries = Object.entries(batchUpdateData);
  //   this.formBatchUpdate(entries);
  //   if (hasDelayUpdate && !isEmpty(delayUpdateData)) {
  //     entries = Object.entries(delayUpdateData);
  //     setTimeout(() => this.formBatchUpdate(entries), delayTimeout);
  //   }
  // };

  verifyOtp = async () => {
    if (this.state.otpValidationInProgress) return;
    this.setState({ otpValidationInProgress: true, isOtpValidated: false });
    const { formApi } = this.props;
    const { values } = formApi.getState();
    const {
      phoneNumber: { number, dialCode },
      otp,
    } = values;
    formApi.change('refOtp', '');
    try {
      const mobileNumber = `${dialCode}${number}`;
      const url = `${apiBaseUrl()}/api/user/validate/phoneotp/mobile`;
      await axios.post(url, { mobile: mobileNumber, otp });

      formApi.change('isPhoneNumberVerified', true);
      this.setState({
        signStep: 1,
        showOtpModal: false,
        otpValidationInProgress: false,
        isOtpValidated: true,
      });
    } catch (err) {
      const entries = [['refOtp', '-1'], ['customOtpErrTextId', 'SignupForm.invalidOtp']];
      this.formBatchUpdate(entries);
      // this.setState({ otpValidationInProgress: false });
      formApi.focus('otp');
      setTimeout(() => formApi.blur('otp'), 100);
      this.setState({
        otpValidationInProgress: false,
        isOtpValidated: false,
        wrongOtpError: err.response.data,
      });
    }
  };
  handleRecaptchStatusChange = value => {
    const { recaptchaStatus } = value;
    const { formApi } = this.props;
    formApi.change('recaptchaStatus', { ...recaptchaStatus });
  };

  handleFormSpyChange = formValues => {
    const { formApi } = this.props;
    const { values, active } = formValues;
    const { refOtp, refEmail } = values;
    // if (active && active.toLowerCase() === 'otp' && !isNaN(parseInt(refOtp))) {
    //   formApi.change('refOtp', '');
    // } else if (active && active.toLowerCase() === 'email' && !!refEmail) {
    //   formApi.change('refEmail', '');
    // }
  };

  handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    // let data = null;
    const { formApi, onSubmit, error, userNativeLang } = this.props;
    const { values } = formApi.getState();
    const {
      recaptchaStatus = {},
      email,

      password,
      lname,
      fname,
      phoneNumber,
      company,
      jobTitle,
      preferredLang,
    } = values;
    const { hasRecaptchaValidated = false } = recaptchaStatus;
    // console.log(5566, values, this.props);
    formApi.change('refEmail', '');
    if (!isEmpty(error) || !hasRecaptchaValidated) return;
    if (this.state.signStep === 0) {
      const { isPhoneNumberVerified } = values;

      if (isPhoneNumberVerified) {
        this.setState({
          signStep: 1,
          isOtpValidated: true,
        });
      } else {
        if (this.state.showOtpModal) {
          this.verifyOtp();
        } else {
          axios
            .post(
              `${apiBaseUrl()}/api/user/ExistingUserStatus`,
              {
                email,
                userNativeLang,
              },
              { withCredentials: true }
            )
            .then(res => {
              // console.log(66, res);
              // data = res?.data || null;
              if (res?.data === 'yes') {
                onSubmit({
                  email,

                  password,
                  lname,
                  fname,
                });
              }
            })
            .catch(err => {
              // console.log(234, err);
              if (err?.response?.status === 404) {
                this.requestForOtp();
              }
            });
          // this.requestForOtp();
        }
      }
    } else if (this.state.signStep === 1) {
      const {
        email,
        password,
        lname,
        fname,
        phoneNumber,
        company,
        jobTitle,
        businessAddress,
        adNewsSource,
        industryType,
        isPhoneNumberVerified,
      } = values;

      if (!isPhoneNumberVerified) {
        this.setState({ signStep: 0, showOtpModal: true });
        return;
      }
      const { number, iso2, iso3, dialCode } = phoneNumber;
      const publicData = {
        companyName: company,
        companyAddress: businessAddress,
        adNewsSource,
        industryType: industryType?.value,
        isProvider: true,
        preferredLang,
      };
      const protectedData = {
        jobTitle,
        phoneNumber: { number, iso2, iso3, dialCode },
        isPhoneNumberVerified,
        isSocialSignup: false,
        timeZone: getDefaultTimeZoneOnBrowser(),
        healthAndSafety: {
          firstName: fname,
          lastName: lname,
          email,
          phoneNumber: { number, iso2, iso3, dialCode },
        },
      };
      const updatedValues = { email, password, lname, fname, publicData, protectedData };
      onSubmit(updatedValues);
    }
  };

  render() {
    const {
      values,
      intl,
      inProgress,
      invalid,
      formId,
      rootClassName,
      className,
      onManageDisableScrolling,
      userNativeLang,
      signupErrorMessage,
      isEmailTakenError,
      socialLoginButtonsMaybe,

      formApi,
    } = this.props;

    const firstNameId = formId ? `${formId}.fname` : 'fname';
    const lastNameId = formId ? `${formId}.lname` : 'lname';
    const companyId = formId ? `${formId}.company` : 'company';
    const jobTitleId = formId ? `${formId}.jobTitle` : 'jobTitle';
    const emailId = formId ? `${formId}.email` : 'email';
    const phoneNumberId = formId ? `${formId}.phoneNumber` : 'phoneNumber';
    const passwordId = formId ? `${formId}.password` : 'password';
    const confirmPasswordId = formId ? `${formId}.confirmPassword` : 'confirmPassword';
    const recaptchaId = formId ? `${formId}.recaptchaStatus` : 'recaptchaStatus';
    const adNewsSourceId = formId ? `${formId}.adNewsSource` : 'adNewsSource';
    const industryTypeId = formId ? `${formId}.industryType` : 'industryType';
    const businessAddressId = formId ? `${formId}.businessAddress` : 'businessAddress';
    const preferredLangId = formId ? `${formId}.preferredLang` : 'preferredLang';

    const {
      lname = '',
      fname = '',
      email = '',
      password = '',
      phoneNumber,
      refEmail = '',
      refOtp = '',
      otp,
      customOtpErrTextId,
      recaptchaStatus = {},
    } = values;
    const { dialCode, number = '' } = phoneNumber;
    const phoneNumberWithDialCode = `${dialCode} ${replaceNumberWithCharacter(number, 'X')}`;

    const { hasRecaptchaValidated = false } = recaptchaStatus;
    const classes = classNames(rootClassName || css.root, className);
    const submitInProgress = inProgress;
    const isFormOtherFieldInvalid = invalid;
    const submitDisabled = isFormOtherFieldInvalid || submitInProgress || !hasRecaptchaValidated;
    const otpTouched = !!otp && !!customOtpErrTextId;
    const customOtpErrText = !!customOtpErrTextId && intl.formatMessage({ id: customOtpErrTextId });
    // email
    const emailLabel = intl.formatMessage({
      id: 'SignupForm.emailLabel',
    });
    const emailPlaceholder = intl.formatMessage({
      id: 'SignupForm.emailPlaceholder',
    });
    const emailRequiredMessage = intl.formatMessage({
      id: 'SignupForm.emailRequired',
    });
    const emailRequired = validators.required(emailRequiredMessage);
    const emailInvalidMessage = intl.formatMessage({
      id: 'SignupForm.emailInvalid',
    });
    const emailExistMessage = intl.formatMessage({
      id: 'SignupForm.emailExist',
    });
    const emailValid = validators.emailFormatValid(emailInvalidMessage);
    const emailExist = validators.isEmailExist(emailExistMessage, refEmail);

    const emailValidator = validators.composeValidators(emailRequired, emailValid, emailExist);

    // password
    const passwordLabel = intl.formatMessage({
      id: 'SignupForm.passwordLabel',
    });
    const passwordPlaceholder = intl.formatMessage({
      id: 'SignupForm.passwordPlaceholder',
    });
    const passwordRequiredMessage = intl.formatMessage({
      id: 'SignupForm.passwordRequired',
    });
    const passwordMinLengthMessage = intl.formatMessage(
      {
        id: 'SignupForm.passwordTooShort',
      },
      {
        minLength: validators.PASSWORD_MIN_LENGTH,
      }
    );
    const passwordMaxLengthMessage = intl.formatMessage(
      {
        id: 'SignupForm.passwordTooLong',
      },
      {
        maxLength: validators.PASSWORD_MAX_LENGTH,
      }
    );

    const passwordRegexRequiredMessage = intl.formatMessage({
      id: 'SignupForm.passwordRegexRequired',
    });
    const passwordMinLength = validators.minLength(
      passwordMinLengthMessage,
      validators.PASSWORD_MIN_LENGTH
    );
    const passwordMaxLength = validators.maxLength(
      passwordMaxLengthMessage,
      validators.PASSWORD_MAX_LENGTH
    );

    const passwordRegexRequired = validators.validatePasswordRegex(passwordRegexRequiredMessage);
    const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);
    const passwordValidators = validators.composeValidators(
      passwordRequired,
      passwordRegexRequired,
      passwordMinLength,
      passwordMaxLength
    );

    // confirm password
    const confirmPasswordLabel = intl.formatMessage({
      id: 'SignupForm.confirmPasswordLabel',
    });
    const confirmPasswordPlaceholder = intl.formatMessage({
      id: 'SignupForm.confirmPasswordPlaceholder',
    });
    const confirmPasswordRequiredMessage = intl.formatMessage({
      id: 'SignupForm.passwordRequired',
    });
    const confirmPasswordMinLengthMessage = intl.formatMessage(
      {
        id: 'SignupForm.passwordTooShort',
      },
      {
        minLength: validators.PASSWORD_MIN_LENGTH,
      }
    );
    const confirmPasswordMaxLengthMessage = intl.formatMessage(
      {
        id: 'SignupForm.passwordTooLong',
      },
      {
        maxLength: validators.PASSWORD_MAX_LENGTH,
      }
    );
    const passwordNotEqualConfirmMessage = intl.formatMessage({
      id: 'SignupForm.confirmPasswordNotEqual',
    });
    const confirmPasswordMinLength = validators.minLength(
      confirmPasswordMinLengthMessage,
      validators.PASSWORD_MIN_LENGTH
    );
    const confirmPasswordMaxLength = validators.maxLength(
      confirmPasswordMaxLengthMessage,
      validators.PASSWORD_MAX_LENGTH
    );
    const confirmPasswordRequired = validators.requiredStringNoTrim(confirmPasswordRequiredMessage);
    const isConfirmPasswordEqualPassword = validators.isEqual(
      passwordNotEqualConfirmMessage,
      password
    );
    const confirmPasswordValidators = validators.composeValidators(
      confirmPasswordRequired,
      passwordRegexRequired,
      isConfirmPasswordEqualPassword,
      confirmPasswordMinLength,
      confirmPasswordMaxLength
    );

    // firstName
    const firstNameLabel = intl.formatMessage({
      id: 'SignupForm.firstNameLabel',
    });
    const firstNamePlaceholder = intl.formatMessage({
      id: 'SignupForm.firstNamePlaceholder',
    });
    const firstNameRequiredMessage = intl.formatMessage({
      id: 'SignupForm.firstNameRequired',
    });
    const firstNameRequired = validators.required(firstNameRequiredMessage);

    // lastName
    const lastNameLabel = intl.formatMessage({
      id: 'SignupForm.lastNameLabel',
    });
    const lastNamePlaceholder = intl.formatMessage({
      id: 'SignupForm.lastNamePlaceholder',
    });
    const lastNameRequiredMessage = intl.formatMessage({
      id: 'SignupForm.lastNameRequired',
    });
    const lastNameRequired = validators.required(lastNameRequiredMessage);

    // phone number
    const phoneNumberLabel = intl.formatMessage({
      id: 'SignupForm.phoneNumbeLabel',
    });
    const phoneNumberPlaceholder = intl.formatMessage({
      id: 'SignupForm.phoneNumbePlaceholder',
    });
    const phoneNumberRequiredMessage = intl.formatMessage({
      id: 'SignupForm.phoneNumbeRequired',
    });
    const phoneNumberRequired = validators.phoneNumberRequired(phoneNumberRequiredMessage);

    // company
    const companyLabel = intl.formatMessage({
      id: 'SignupForm.companyLabel',
    });
    const companyPlaceholder = intl.formatMessage({
      id: 'SignupForm.companyPlaceholder',
    });
    const companyRequiredMessage = intl.formatMessage({
      id: 'SignupForm.companyRequired',
    });
    const companyRequired = validators.required(companyRequiredMessage);

    // job title
    const jobTitleLabel = intl.formatMessage({
      id: 'SignupForm.jobTitleLabel',
    });
    const jobTitlePlaceholder = intl.formatMessage({
      id: 'SignupForm.jobTitlePlaceholder',
    });
    const jobTitleRequiredMessage = intl.formatMessage({
      id: 'SignupForm.jobTitleRequired',
    });
    const jobTitleRequired = validators.required(jobTitleRequiredMessage);

    //otp
    const otpPlaceholder = intl.formatMessage({
      id: 'SignupForm.otpPlaceholder',
    });
    const otpRequiredMessage = intl.formatMessage({
      id: 'SignupForm.otpRequired',
    });
    // const otpInvalidMessage = intl.formatMessage({
    //   id: 'SignupForm.invalidOtp',
    // });

    const otpValidator = validators.composeValidators(
      validators.required(otpRequiredMessage)
      // validators.isValidOtp(otpInvalidMessage, refOtp)
    );

    //advertising source
    const adNewsSourceLabel = intl.formatMessage({ id: 'SignupForm.adNewsSource' });
    const sourcesOptions = sosAdOptions.map(option => ({
      key: option.value,
      label: option.label[userNativeLang],
    }));

    // industry Type
    const industryTypeLabel = intl.formatMessage({
      id: 'SignupForm.industryTypeLabel',
    });
    const industryTypePlaceholder = intl.formatMessage({
      id: 'SignupForm.industryTypePlaceholder',
    });
    const industryTypeRequiredMessage = intl.formatMessage({
      id: 'SignupForm.industryTypeRequired',
    });
    const industryTypeRequired = validators.required(industryTypeRequiredMessage);

    // business address
    const addressLabel = intl.formatMessage({
      id: 'SignupForm.adrressLabel',
    });
    const addressPlaceholder = intl.formatMessage({
      id: 'SignupForm.adrressPlaceholder',
    });
    const postalLabel = intl.formatMessage({
      id: 'SignupForm.postalLabel',
    });
    const postalPlaceholder = intl.formatMessage({
      id: 'SignupForm.postalPlaceholder',
    });
    const addressRequiredMessage = intl.formatMessage({
      id: 'SignupForm.adrressRequired',
    });
    const addressRequired = validators.addressRequired(addressRequiredMessage);

    const loginLink = (
      <NamedLink name="LoginPage" className={css.loginLink}>
        <FormattedMessage id="TopbarDesktop.login" />
      </NamedLink>
    );

    const termsLink = (
      <NamedLink name="TermsOfServicePage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.termsAndConditionsLinkText" />
      </NamedLink>
    );

    const policyLink = (
      <NamedLink name="PrivacyPolicyPage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.policyLinkText" />
      </NamedLink>
    );

    const contactUsLink = (
      <NamedLink name="ContactUsPage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.contactusLinkText" />
      </NamedLink>
    );

    const handleResendOtp = e => {
      this.setState({ otpResend: true });
      this.requestForOtp().then(() => {
        setTimeout(() => {
          this.setState({ otpResend: false });
        }, 1300);
      });
    };
    return (
      <Form className={classes} onSubmit={this.handleSubmit}>
        <FormSpy
          subscription={{ values: true, active: true }}
          onChange={this.handleFormSpyChange}
        />
        <div className={css.formTitle}>
          <h1 className={css.heading}>
            {this.state.signStep == 0 ? (
              <FormattedMessage id="SignupForm.BusinessHeading" />
            ) : (
              <FormattedMessage id="SignupForm.HeadingSecond" />
            )}
            {/* <FormattedMessage id="SignupForm.Heading" /> */}
          </h1>
        </div>
        {this.state.signStep == 0 ? (
          <React.Fragment>
            <div className={css.subHeading}>
              <FormattedMessage id="SignupForm.subHeading" values={{ loginLink }} />
            </div>
            <div className={css.ProviderSignupWrap}>
              <div className={css.row}>
                <FieldTextInput
                  className={textfield}
                  errorClassName={errorTextField}
                  type="text"
                  id={firstNameId}
                  name="fname"
                  autoComplete="given-name"
                  label={firstNameLabel}
                  placeholder={firstNamePlaceholder}
                  validate={firstNameRequired}
                />
                <FieldTextInput
                  className={textfield}
                  errorClassName={errorTextField}
                  type="text"
                  id={lastNameId}
                  name="lname"
                  autoComplete="family-name"
                  label={lastNameLabel}
                  placeholder={lastNamePlaceholder}
                  validate={lastNameRequired}
                />
              </div>
              <div className={css.row}>
                <FieldTextInput
                  className={textfield}
                  errorClassName={errorTextField}
                  type="text"
                  id={companyId}
                  name="company"
                  autoComplete="company"
                  label={companyLabel}
                  placeholder={companyPlaceholder}
                  validate={companyRequired}
                />
                <FieldTextInput
                  className={textfield}
                  errorClassName={errorTextField}
                  type="text"
                  name="jobTitle"
                  id={jobTitleId}
                  label={jobTitleLabel}
                  placeholder={jobTitlePlaceholder}
                  // validate={jobTitleRequired}
                />
              </div>
              <div className={css.row}>
                <FieldTextInput
                  className={textfield}
                  errorClassName={errorTextField}
                  type="email"
                  id={emailId}
                  name="email"
                  autoComplete="email"
                  label={emailLabel}
                  placeholder={emailPlaceholder}
                  validate={emailValidator}
                  key={refEmail}
                />
                <FieldPhoneNumberInputWithDialCode
                  name="phoneNumber"
                  id={phoneNumberId}
                  label={phoneNumberLabel}
                  placeholder={phoneNumberPlaceholder}
                  validate={phoneNumberRequired}
                  className={textfield}
                  errorClassName={errorTextField}
                />
              </div>
              <div className={css.row}>
                <FieldPassword
                  className={classNames(css.password, textfield)}
                  errorClassName={errorTextField}
                  id={passwordId}
                  name="password"
                  autoComplete="new-password"
                  label={passwordLabel}
                  placeholder={passwordPlaceholder}
                  validate={passwordValidators}
                  passwordCheckRefValues={[fname, lname, email]}
                />
                <FieldPassword
                  className={classNames(css.password, textfield)}
                  errorClassName={errorTextField}
                  id={confirmPasswordId}
                  name="confirmPassword"
                  label={confirmPasswordLabel}
                  placeholder={confirmPasswordPlaceholder}
                  validate={confirmPasswordValidators}
                  passwordCheckRefValues={[fname, lname, email]}
                  refValue={password}
                />
              </div>

              <div>
                <FieldPerferredLang
                  id={preferredLangId}
                  userNativeLang={userNativeLang}
                  name="preferredLang"
                  className={textfield}
                  errorClassName={errorTextField}
                />
              </div>
            </div>

            <FieldRecaptcha
              id={recaptchaId}
              name="recaptchaStatus"
              enableRecaptcha={!isFormOtherFieldInvalid}
              onChange={this.handleRecaptchStatusChange}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* <h3 className={css.subHeading}>
              <FormattedMessage id="SignupForm.subHeading" values={{ loginLink }} />
            </h3> */}
            <FieldAddress
              id={businessAddressId}
              name="businessAddress"
              addressLabel={addressLabel}
              addressPlaceholder={addressPlaceholder}
              postalLabel={postalLabel}
              postalPlaceholder={postalPlaceholder}
              className={textfield}
              errorClassName={errorTextField}
              validate={addressRequired}
              userNativeLang={userNativeLang}
            />
            <FieldCustomSelect
              userNativeLang={userNativeLang}
              options={Object.values(listingTypes)}
              // options={industryOptions}
              id={industryTypeId}
              name="industryType"
              label={industryTypeLabel}
              placeholder={industryTypePlaceholder}
              validate={industryTypeRequired}
              className={textfield}
              errorClassName={errorTextField}
              isSearchable={true}
            />
            <FieldRadioButtonGroup
              label={adNewsSourceLabel}
              name="adNewsSource"
              id={adNewsSourceId}
              options={sourcesOptions}
            />
          </React.Fragment>
        )}

        <div className={css.bottomWrapper}>
          {!isEmailTakenError && signupErrorMessage}
          <div className={css.btnWrapper}>
            <PrimaryButton
              type="submit"
              inProgress={submitInProgress && !this.state.showOtpModal}
              disabled={submitDisabled || this.state.showOtpModal}
              className={css.submitBtn}
            >
              <FormattedMessage
                id={this.state.signStep === 0 ? 'SignupForm.signUp' : 'SignupForm.signUpContinue'}
              />
            </PrimaryButton>
            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={this.handleOnCancelBtnClick}
            >
              <FormattedMessage id="SignupForm.signUpCancel" />
            </InlineTextButton>
          </div>
          {/*className={css.bottomWrapperText}*/}

          <p className={css.helperTextWrapper}>
            {this.state.signStep === 0 && (
              <span className={css.termsText}>
                <FormattedMessage
                  id="SignupForm.termsAndConditionsAcceptText"
                  values={{ termsLink, policyLink }}
                />
              </span>
            )}
            <span>
              <FormattedMessage id="SignupForm.contactusText" values={{ contactUsLink }} />
            </span>
          </p>

          {this.state.signStep === 0 && <div>{socialLoginButtonsMaybe}</div>}
        </div>

        <Modal
          id="ProviderSignup.verifyotp"
          className={css.verifyModal}
          isOpen={this.state.showOtpModal}
          onClose={this.checkAndHideOtpModal}
          onManageDisableScrolling={onManageDisableScrolling}
          showCloseButtonMessage={false}
        >
          {this.state.showOtpModal && (
            <div className={css.otpContentWrapper}>
              <div className={css.contentHeading}>
                <h3 className={css.heading}>
                  {intl.formatMessage({ id: 'SignupForm.otpHeading' })}
                </h3>
                <p className={css.subHeading}>
                  {intl.formatMessage({ id: 'SignupForm.otpSubheading' })}
                </p>
                <div className={css.Otpdetails}>
                  <div className={css.changeNumberWrapper}>
                    <span className={css.changeNumberText}>{phoneNumberWithDialCode}</span>
                    <InlineTextButton
                      type="button"
                      className={css.changeNumberBtn}
                      onClick={this.checkAndHideOtpModal}
                    >
                      {intl.formatMessage({ id: 'SignupForm.changeNumberText' })}
                    </InlineTextButton>
                  </div>
                  <FieldNumberInput
                    id="otp"
                    name="otp"
                    placeholder={otpPlaceholder}
                    validate={otpValidator}
                    className={textfield}
                    errorClassName={errorTextField}
                    key={refOtp}
                    onChange={e => {
                      formApi.batch(() => {
                        formApi.change('customOtpErrTextId', '');
                        formApi.change('otp', e);
                      });
                    }}
                    customErrorText={otpTouched ? customOtpErrText : null}
                  />
                  <div className={css.noOtpWrapper}>
                    {this.state.otpResend ? (
                      <FormattedMessage id="LoginForm.resendingOtpInfo" />
                    ) : (
                      <>
                        <span className={css.noOtpText}>
                          {intl.formatMessage({ id: 'SignupForm.noOtpText' })}
                        </span>
                        <InlineTextButton
                          type="button"
                          className={css.noOtpBtn}
                          // onClick={this.requestForOtp}
                          onClick={handleResendOtp}
                        >
                          {intl.formatMessage({ id: 'SignupForm.resendOtpText' })}
                        </InlineTextButton>
                      </>
                    )}
                  </div>
                </div>

                <SecondaryButton
                  type="button"
                  // className={classNames(css.otpCheckBtn, {})}
                  className={css.otpCheckBtn}
                  inProgress={this.state.otpValidationInProgress}
                  onClick={this.verifyOtp}
                  disabled={!values.otp || customOtpErrText}
                >
                  {intl.formatMessage({ id: 'SignupForm.otpHeading' })}
                </SecondaryButton>
              </div>
            </div>
          )}
        </Modal>
      </Form>
    );
  }
}
